import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../../lib/route-guard.js';

export const Route = createFileRoute('/integrations/sage-intacct')({
  component: () => <RouteGuard route="/integrations/sage-intacct" />,
});
